import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"map-search"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21 16.25C21 18.3211 19.3211 20 17.25 20C15.1789 20 13.5 18.3211 13.5 16.25C13.5 14.1789 15.1789 12.5 17.25 12.5C19.3211 12.5 21 14.1789 21 16.25Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 6.5L9 3L3 6.5V20L9 17.5M15 6.5L21 4V9.5M15 6.5V9.5M9 17.5V3.5M9 17.5L10.5 18.375","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M19.9036 18.8997L21.5 20.5M21 16.25C21 18.3211 19.3211 20 17.25 20C15.1789 20 13.5 18.3211 13.5 16.25C13.5 14.1789 15.1789 12.5 17.25 12.5C19.3211 12.5 21 14.1789 21 16.25Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MapSearch = Vue.extend<IconProps>({
  name: 'MapSearchIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'map-search',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MapSearch;
